import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

export const ErrorPageWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const ErrorTitle = styled.span`
  font-size: 48px;
  font-weight: 700;
`
export const ErrorText = styled.span`
  margin-top: 15px;
  font-size: 25px;
  font-weight: 500;
`

export const ErrorButton = styled.button`
  width: 130px;
  margin-top: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.4s all;
  border-radius: 20px;
  background-color: ${GLOBAL_COLORS.ultramarine};
  color: ${GLOBAL_COLORS.white};
  border: 1px solid ${GLOBAL_COLORS.ultramarine};
  font-weight: 500;
  &:hover {
    background-color: ${GLOBAL_COLORS.darkUltramarine};
    border: 1px solid ${GLOBAL_COLORS.darkUltramarine};
    color: ${GLOBAL_COLORS.white};
  }
`
